module.exports = __webpack_public_path__ + "img/figure_1.1e803534.png";